'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactScrollspy = require('react-scrollspy');

var _reactScrollspy2 = _interopRequireDefault(_reactScrollspy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable import/no-extraneous-dependencies */

var UANav = function (_React$Component) {
  _inherits(UANav, _React$Component);

  function UANav() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UANav);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UANav.__proto__ || Object.getPrototypeOf(UANav)).call.apply(_ref, [this].concat(args))), _this), _this.renderSections = function (sections, currentSectionIndex, currentSubSectionIndex) {
      return sections.map(function (section, sectionIndex) {
        var anchorLink = section.anchorLink,
            headline = section.headline,
            subsections = section.subsections;

        var sectionClasses = (0, _classnames2.default)('section-' + (sectionIndex + 1), subsections.length ? 'item-has-children' : '', currentSectionIndex === sectionIndex ? 'active' : '');
        var sectionId = anchorLink && anchorLink.text ? anchorLink.text : 'UASection-' + sectionIndex;
        var subsectionsIds = subsections.map(function (ss, i) {
          return ss.anchorLink && ss.anchorLink.text ? ss.anchorLink.text : 'UASubSection-' + sectionIndex + '-' + i;
        });
        return _react2.default.createElement(
          'li',
          {
            id: 'section-' + sectionIndex + '-nav',
            key: 'section-' + sectionIndex + '-nav',
            className: sectionClasses
          },
          _react2.default.createElement(
            'a',
            { className: 'section-parent', href: '#' + sectionId },
            _react2.default.createElement(
              'span',
              null,
              headline.text
            )
          ),
          subsections.length && _react2.default.createElement(
            _reactScrollspy2.default,
            {
              items: subsectionsIds,
              currentClassName: 'active',
              className: 'sub-menu',
              offset: 175
            },
            _this.renderSubSections(subsections, sectionIndex, currentSubSectionIndex)
          )
        );
      });
    }, _this.renderSubSections = function (subSections, currentSectionIndex) {
      return subSections.map(function (subSection, index) {
        var anchorLink = subSection.anchorLink,
            headline = subSection.headline;

        var id = anchorLink && anchorLink.text ? anchorLink.text : 'UASubSection-' + currentSectionIndex + '-' + index;
        var subSectionClasses = (0, _classnames2.default)('subsection-' + index
        // currentSubSectionIndex === index ? 'active' : ''
        );
        return _react2.default.createElement(
          'li',
          {
            id: 'subsection-' + currentSectionIndex + '-' + index + '-nav',
            key: 'subsection-' + currentSectionIndex + '-' + index + '-nav',
            className: subSectionClasses
          },
          _react2.default.createElement(
            'a',
            { href: '#' + id },
            _react2.default.createElement(
              'span',
              null,
              headline.text
            )
          )
        );
      });
    }, _this.renderBackLink = function (backLink) {
      if (backLink && backLink.text) {
        return _react2.default.createElement(
          'div',
          { className: 'back-link' },
          _react2.default.createElement(
            'a',
            { href: backLink.href },
            _react2.default.createElement(
              'span',
              null,
              '\xA0'
            ),
            _react2.default.createElement(
              'span',
              null,
              '\xA0'
            ),
            backLink.text
          )
        );
      }
      return null;
    }, _this.renderPDF = function (pdf) {
      if (pdf && pdf.text) {
        return _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            'a',
            { className: 'btn ua-pdf', href: pdf.href },
            pdf.text
          )
        );
      }
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UANav, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          sections = _props.sections,
          className = _props.className,
          currentSectionIndex = _props.currentSectionIndex,
          currentSubSectionIndex = _props.currentSubSectionIndex,
          isNavOpen = _props.isNavOpen,
          setNavRef = _props.setNavRef,
          backLink = _props.backLink,
          pdf = _props.pdf;

      var navClasses = (0, _classnames2.default)(className, 'ua-nav', isNavOpen ? 'menu-open' : '');
      return _react2.default.createElement(
        'nav',
        {
          id: 'UANav',
          className: navClasses,
          ref: function ref(el) {
            return setNavRef(el);
          }
        },
        this.renderBackLink(backLink),
        _react2.default.createElement(
          'ul',
          { className: 'pp-navigation nav' },
          this.renderSections(sections, currentSectionIndex, currentSubSectionIndex),
          this.renderPDF(pdf)
        )
      );
    }
  }]);

  return UANav;
}(_react2.default.Component);

exports.default = UANav;


UANav.propTypes = {
  currentSectionIndex: _propTypes2.default.number.isRequired,
  currentSubSectionIndex: _propTypes2.default.number.isRequired,
  setNavRef: _propTypes2.default.func.isRequired,
  isNavOpen: _propTypes2.default.bool,
  backLink: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired,
    href: _propTypes2.default.string.isRequired
  }),
  pdf: _propTypes2.default.shape({
    text: _propTypes2.default.string,
    href: _propTypes2.default.string
  }),
  sections: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  className: _propTypes2.default.string
};

UANav.defaultProps = {
  isNavOpen: false,
  backLink: {
    href: '',
    text: ''
  },
  pdf: {
    text: '',
    href: ''
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/user-agreement/jsx/UANav.js
// module id = 1154
// module chunks = 4